import { send } from "../api.js";

/**
 * Result returned by WMF-SIte's authoritative appointment-status mutation.
 *
 * Checked against the current Phase 4D contract on 30 August 2026. Attendance
 * status is changed in Amelia by WMF-SIte; the Hub never mutates a mirror row
 * directly. Credit consequences, if any, are also reported by that service.
 */
export interface AppointmentStatusChangeResult {
  appointment: {
    id: number;
    status: string;
  };
  credits_restored: number;
  credit_review_required?: boolean;
}

/** Record a missed appointment as a no-show; this is not a cancellation. */
export function markAppointmentNoShow(
  appointmentId: number,
  idempotencyKey?: string,
): Promise<AppointmentStatusChangeResult> {
  return send<AppointmentStatusChangeResult>(
    "PATCH",
    `/staff-api/api/v1/appointments/${appointmentId}/status`,
    { status: "no-show" },
    idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
  );
}


/** Undo an accidental no-show without changing the lesson's funding. */
export function undoAppointmentNoShow(
  appointmentId: number,
  idempotencyKey?: string,
): Promise<AppointmentStatusChangeResult> {
  return send<AppointmentStatusChangeResult>(
    "PATCH",
    `/staff-api/api/v1/appointments/${appointmentId}/status`,
    { status: "approved", notify_participants: false },
    idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
  );
}

/** Reinstate a credit-neutral cancellation using the booking service's rules. */
export function reinstateCancelledAppointment(
  appointmentId: number,
  notifyParticipants: boolean,
  idempotencyKey: string,
): Promise<AppointmentStatusChangeResult> {
  return send<AppointmentStatusChangeResult>(
    "PATCH",
    `/staff-api/api/v1/appointments/${appointmentId}/status`,
    { status: "approved", notify_participants: notifyParticipants },
    { "Idempotency-Key": idempotencyKey },
  );
}
